import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import Langtrans from "../../components/Langtrans/Langtrans";
import Buttons from "../../components/Button/Button";
import "./Dashboard.scss";
import { useSelector, useDispatch } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { campaignData } from "../../store/action";
import { API, graphqlOperation } from "aws-amplify";
import { deleteProductTable } from "../../graphql/mutations";
import { UseWindowSize } from "../../hooks/Usewindow";
import CampaignTable from "./CampaignTable";
import { productData } from "../../store/action";
const Campaign = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const campaign = useSelector((state) => state.campaign.campaign);
  const logindata = useSelector((state) => state.login);
  const [filterKeywords, setfilterKeywords] = useState("");
  const dispatch = useDispatch();
  const [msg, setMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [product, setProduct] = useState([]);
  const [campaignStatus, setCampaignStatus] = useState("inProgress");
  const [ordersData, setOrdersData] = useState([]);
  const width = UseWindowSize();
  const remainDate = (createdAt, days) => {
    if (product) {
      const currentDate = moment(createdAt, "YYYY-MM-DD");
      const futureDate = moment(currentDate._d).add(days, "days");
      const endDate = moment(futureDate._d).format("YYYY-MM-DD");
      const todaysdate = moment();
      return moment(endDate).diff(todaysdate, "days");
    }
  };
  const AddtoCart = (data) => {
    const exist = campaign?.find((item) => item.id === data?.id);
    if (exist) {
      history.push("/order");
      dispatch(
        campaignData({
          campaign: campaign.map((x) =>
            x.id === data?.id ? { ...exist, quantity: exist.quantity + 1 } : x
          ),
        })
      );
    } else {
      history.push("/order");
      dispatch(
        campaignData({
          campaign: [...campaign, { ...data, quantity: 1 }],
        })
      );
    }
  };
  const filterArray = () =>
    campaign?.filter((val) => {
      if (filterKeywords === "") {
        return val;
      } else if (
        Object.values(val)
          ?.join(" ")
          ?.toLowerCase()
          ?.includes(filterKeywords?.toLowerCase())
      ) {
        return val;
      }
    });
  const deleteshirt = async (data) => {
    // console.log(data.id);
    try {
      const data1 = await API.graphql(
        graphqlOperation(deleteProductTable, { input: { id: data.id } })
      );
      setMsg("Successfully deleted");
      dispatch(
        campaignData({
          campaign: campaign.filter(
            (exp, index) => exp.id !== data1?.data.deleteProductTable.id
          ),
        })
      );
      dispatch(
        productData({
          id: "",
          step: 0,
          shirt: {},
          designnimg: "",
          color: "",
          realprice: 0,
          price: 0,
          day: 0,
          sales: 0,
          shirtname: "",
          brief: "",
          detail: "",
          campaign: 0,
          shirtdesign: [],
          shirtdesignback: [],
          frontDesignObj: null,
          backDesignObj: null,
          alterImage: null,
          edit: false,
          hello: {},
          seldata: false,
          shirtsdata1: "",
          shirtsdata2: "",
          designnimgback: "",
        })
      );
      setTimeout(() => {
        setMsg("");
      }, 15000);
    } catch (error) {
      //   console.log("error");
      setErrMsg(error.message);
      setTimeout(() => {
        setErrMsg("");
      }, 1500);
    }
  };
  useEffect(() => {
    API.get("laetusapi", "/api/v1/getorders")
      .then((res) => {
        setOrdersData(res);
      })
      .catch((err) => {
        return err;
      });
  }, []);

  return (
    <>
      <div className="home">
        <div className="left">
          <CustomerDashboard />
        </div>
        <div className="right">
          <div className="top">
            <h4>{t("campaign")}</h4>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-arround",
              }}
            >
              <Buttons
                style={{ width: "180px" }}
                text={t("new-campaign")}
                onClick={() => history.push("/")}
              />
              <Langtrans
                style={{ marginRight: "0px", marginTop: "0px", height: "36px" }}
                dashboard
              />
            </div>
          </div>
          <div
            className="bottom"
            style={{
              minHeight: "100vh",
              maxHeight: "100%",
              paddingBottom: "0px",
            }}
          >
            <hr />
            {campaign.length < 1 ? (
              <div className="bottom-top">
                <div
                  className="card"
                  style={{
                    width: "50%",
                    height: "175px",
                    paddingTop: "10px",
                    textAlign: "center",
                    marginTop: campaign.length < 1 && "300px",
                  }}
                >
                  {width.width > 1300 ? <h2></h2> : null}
                  <div className="cal-div" style={{ height: "125px" }}>
                    <div>
                      {width.width > 1300 ? (
                        <h2>{t("no-campaign-launched")}</h2>
                      ) : (
                        <h3>{t("no-campaign-launched")}</h3>
                      )}
                      <Buttons
                        text={`> ${t("my-campaign")}`}
                        className="campaign-btn btn"
                        style={{
                          marginTop: width.width > 1512 ? "25px" : "10px",
                        }}
                        onClick={() => history.push("/")}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="searchdiv">
                  <input
                    type="text"
                    placeholder={t("search-camp")}
                    className="search"
                    onChange={(e) => setfilterKeywords(e.target.value)}
                    value={filterKeywords}
                  />
                  <div className="searchicon">
                    <SearchIcon />
                  </div>
                </div>
                <div
                  className="bottom-tail"
                  style={{
                    width: "43%",
                    marginTop: "50px",
                    marginBottom: "10px",
                  }}
                >
                  <div
                    className={`${
                      campaignStatus === "inProgress" && "active"
                    } ${"sel"}`}
                    onClick={() => setCampaignStatus("inProgress")}
                  >
                    <p>
                      <b>{t("cur-campaign")}</b>
                    </p>
                  </div>
                  <div
                    className={`${
                      campaignStatus === "completed" && "active"
                    } ${"sel"}`}
                    onClick={() => setCampaignStatus("completed")}
                  >
                    <p>
                      <b>{t("camp-complete")}</b>
                    </p>
                  </div>
                  <div
                    className={`${
                      campaignStatus === "inDraft" && "active"
                    } ${"sel"}`}
                    onClick={() => setCampaignStatus("inDraft")}
                  >
                    <p>
                      <b>{t("draft")}</b>
                    </p>
                  </div>
                </div>
                <table
                  style={{ width: "100%", textAlign: "left" }}
                  CELLSPACING="0"
                  CELLPADDING="0"
                >
                  <thead>
                    <tr>
                      <th style={{ width: "350px" }}>
                        <div
                          style={{
                            textTransform: "uppercase",
                          }}
                        >
                          <h3 style={{ fontWeight: "bold" }}>
                            {t(
                              campaignStatus === "inProgress"
                                ? "cur-campaign"
                                : campaignStatus === "inDraft"
                                ? "draft"
                                : "camp-complete"
                            )}
                          </h3>
                        </div>
                      </th>
                      <th style={{ width: "250px", fontFamily: "Roboto" }}>
                        <small>
                          <b>{t("remain-time")}</b>
                        </small>
                      </th>
                      <th style={{ fontFamily: "Roboto" }}>
                        <small>
                          <b>{t("nb-pre-orders")}</b>
                        </small>
                      </th>
                      <th style={{ fontFamily: "Roboto" }}>
                        <small>
                          <b>{t("gains")}</b>
                        </small>
                      </th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                      <td>
                        <hr />
                      </td>
                    </tr>
                    {filterArray()?.map((data, ind) => {
                      return data.isDone &&
                        !data.isStop &&
                        campaignStatus === "inProgress" &&
                        remainDate(data.createdAt, data.days) + 1 > 0 ? (
                        <>
                          <CampaignTable
                            data={data}
                            remainDate={remainDate}
                            key={ind}
                            AddtoCart={AddtoCart}
                            deleteshirt={() => deleteshirt(data)}
                            inProgress
                          />
                        </>
                      ) : !data.isDone && campaignStatus === "inDraft" ? (
                        <>
                          <CampaignTable
                            data={data}
                            remainDate={remainDate}
                            deleteshirt={() => deleteshirt(data)}
                            key={ind}
                            inDraft
                            AddtoCart={AddtoCart}
                          />
                        </>
                      ) : ((data.isDone &&
                          remainDate(data.createdAt, data.days) + 1 <= 0) ||
                          data.isStop) &&
                        campaignStatus === "completed" ? (
                        <>
                          <CampaignTable
                            data={data}
                            remainDate={remainDate}
                            key={ind}
                            deleteshirt={() => deleteshirt(data)}
                            AddtoCart={AddtoCart}
                            completed
                          />
                        </>
                      ) : null;
                    })}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default Campaign;
